export {
  SectionHeading,
  SectionHeadingSmall,
  SubSectionHeading,
} from './SectionHeading.styled';
